import { Fragment } from "react/jsx-runtime";

import "./key-shortcut.scss";

export type KeyShortcutItem = string | SpecialKeys;

export enum SpecialKeys {
  CTRL = "CTRL",
  SHIFT = "SHIFT",
  ALT = "ALT",
  META = "META",
  ESCAPE = "ESCAPE",
  ENTER = "ENTER",
  DELETE = "DELETE",
}

const getOSKeySymbol = (key: string | SpecialKeys, isMac: boolean) => {
  switch (key) {
    case SpecialKeys.CTRL:
      return isMac ? "⌃" : "CTRL";
    case SpecialKeys.SHIFT:
      return "⇧";
    case SpecialKeys.ALT:
      return isMac ? "⌥" : "ALT";
    case SpecialKeys.META:
      return isMac ? "⌘" : "META";
    case SpecialKeys.ESCAPE:
      return "ESC";
    case SpecialKeys.ENTER:
      return "↵";
    case SpecialKeys.DELETE:
      return "DEL";
    default:
      return key;
  }
};

export const KeyShortcut = ({
  hotkeys,
}: {
  hotkeys: (string | SpecialKeys)[];
}) => {
  const isMac = navigator.userAgent.includes("Mac");

  return (
    <div className="key-shortcut">
      {hotkeys.map((hotkey, index) => (
        <Fragment key={`${hotkey}-${index}`}>
          <span className="key-shortcut__key">
            {getOSKeySymbol(hotkey, isMac)}
          </span>
          {index < hotkeys.length - 1 && (
            <span className="key-shortcut__separator">+</span>
          )}
        </Fragment>
      ))}
    </div>
  );
};
